// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1prGR","header":"PatientQuestionnaire_header__3Y7m5","info":"PatientQuestionnaire_info__a4DPJ"};